import Header from '/business/shared/components/widgets/header/Header';

function AuthLayoutHeader() {
  return <Header />;
}

export default AuthLayoutHeader;
